export const CHUNK_SIZE = 1024 * 10_000; // 50MB
